import wholesale from '@/api/wholesale/operation'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  products: [],
  customers: [],
  employees: [],
  discountPromotion: [],
  freeItemPerAmount: [],
  freeCoinPerAmount: [],
  buyItemFreeItem: [],
  discountByRange: [],
  quotations: [],
  salecontracts: [],
  location_id: [],
  branch_id: [],
  is_paid: undefined,
  dateRange: [
    moment()
      .add(-1, 'months')
      .format('DD-MM-YYYY'),
    moment().format('DD-MM-YYYY')
  ],
  searchAllDate: false,
  is_deleted: false,
  setting: {}
}

export const getters = {
  getProduct: state => ({ chosenProduct, search = '' } = {}) => {
    if (chosenProduct !== undefined) {
      return state.products
        .filter(
          p =>
            !_.includes(
              chosenProduct.map(el => el.product_id),
              p.product_id
            )
        )
        .filter(
          p =>
            search
              .split(' ')
              .every(s =>
                p.product_name_en.toLowerCase().includes(s.toLowerCase())
              ) ||
            search
              .split(' ')
              .every(s => p.barcode.toLowerCase().includes(s.toLowerCase()))
        )
        .slice(0, 400)
    }
    return state.products.slice(0, 400)
  },
  getUom: state => productId => {
    return state.products
      .filter(p => p.product_id == productId)
      .map(el => el.uom_category.unit_of_measures)
      .flat()
  },
  isDefaultUom: state => productId => {
    if (productId) {
      return state.products
        .filter(p => p.product_id == productId)
        .map(el => el.uom_category.unit_of_measures)
        .flat()
        .filter(d => d.is_default == true)
        .map(el => el.uom_id)
        .reduce((init, value) => (init = value))
    }
    return null
  },
  getSalePrice: state => ({ product_id, uom_id }) => {
    let product = state.products.find(p => p.product_id == product_id)
    var price = product.sale_code.find(s => s.uom_id == uom_id)
    if (price) {
      return price.product_price.sale_price
    }
    return 0
  },
  getCost: state => ({ product_id, uom_id = null }) => {
    if (product_id && state.products.length) {
      let pro = state.products.find(p => p.product_id == product_id)
      var uom = pro.uom_category.unit_of_measures.find(u =>
        uom_id ? u.uom_id == uom_id : u.is_default == true
      )
      var salecode = pro.sale_code.find(s => s.uom_id == uom.uom_id)
      return salecode.product_price
        ? salecode.product_price.cost
          ? salecode.product_price.cost
          : 0
        : 0
    }
    return 0
  },
  getDiscount: state => ({ product_id, uom_id }) => {
    return state.discountPromotion
      .filter(d => d.product_id == product_id && d.uom_id == uom_id)
      .reduce((i, v) => (i = v.promo_discount_value), 0)
  },
  getItemPeramount: state => subTotal => {
    return state.freeItemPerAmount.filter(a => {
      if (a.operator_sign == 'between') {
        return _.inRange(subTotal, a.amount_from, a.amount_to ? a.amount_to : 0)
      } else if (a.operator_sign == '>=') {
        return subTotal >= a.amount_from
      } else {
        return []
      }
    })
  },
  getFreeItemBuyItem: state => ({ product_id, uom_id, qty }) => {
    return state.buyItemFreeItem.filter(
      i =>
        i.product_buy_id == product_id &&
        i.uom_buy_id == uom_id &&
        qty >= i.buy_quantity
    )
  },
  getSpecification: state => ({ product_id, uom_id }) => {
    if (product_id && uom_id) {
      let r = state.products
        .filter(p => p.product_id == product_id)
        .reduce((i, v) => (i = v.sale_code), [])
        .filter(s => s.uom_id == uom_id)
      if (r[0].specification) {
        return r[0].specification.specification
      }
    } else {
      return null
    }
  },
  getQuotationItem: state => quotation_id => {
    return state.quotations.filter(q => q.quotation_id == quotation_id)
  },
  getSalecontractItem: state => contract_id => {
    return state.salecontracts.filter(q => q.contract_id == contract_id)
  },
  findProduct: state => productId => {
    if (!productId) {
      return {
        barcode: null,
        product_name_en: null
      }
    }
    return state.products.find(p => p.product_id == productId)
  },
  getRangeDiscountForProduct: (state) => (product) => {
    const quantity = parseFloat(product.quantity)
    const unitPrice = parseFloat(product.unit_price)
    const amount = quantity * unitPrice
    const productId = product.product_id
    const uomId = product.uom_id    

    for (const promo of state.discountByRange) {
      const conditions = promo.condition.filter(
        (cond) =>
          cond.product_id === productId &&
          cond.uom_id === uomId
      )
      
      for (const cond of conditions) {
        const rangeType = cond.range_type
        const valueToCompare = rangeType === 1 ? quantity : amount
        const min = cond.input_amount_from != null ? cond.input_amount_from : 0
        const max = cond.input_amount_to != null ? cond.input_amount_to : Infinity

        const isMatch =
          (cond.operator_sign === ">=" && valueToCompare >= min) ||
          (cond.operator_sign === "between" && valueToCompare >= min && valueToCompare <= max) ||
          (cond.operator_sign === "=" && valueToCompare === min)

        if (isMatch) {
          return {
            ...cond,
            promo_type_id: promo.promo_type_id,
            promotion_id: promo.promotion_id
          }
        }
      }
    }

    return null // No matching promotion
  },
  getDiscountPromotionForProduct: (state) => (product) => {
    const promotion = state.discountPromotion.find(
      d => d.product_id === product.product_id && d.uom_id === product.uom_id
    )

    if (promotion && parseFloat(product.quantity) >= parseFloat(promotion.quantity)) {
      return {
        promo_type_id: promotion.promo_type_id,
        discount_rate: promotion.promo_discount_value
      }
    }

    return null
  }
}

export const mutations = {
  ...baseMutations,
  SET_DATE_RANGE(state, date) {
    state.dateRange = date
  },
  SET_SEARCH_ALL_DATE(state, data) {
    state.searchAllDate = data
  },
  SET_PRODUCT(state, data) {
    let checkExist = state.products.find(p => p.product_id == data.product_id)
    if (!checkExist) {
      state.products.push(data)
    }
  },
  SET_CUSTOMER(state, data) {
    state.customers = data
  },
  PUSH_NEW_CUSTOMER(state, data) {
    // if not exists
    let exist = state.customers.find(c => c.customer_id == data.customer_id)
    if (!exist) {
      state.customers.push(data)
    }
  },
  SET_EMPLOYEE(state, data) {
    state.employees = data
  },
  PUSH_EMPLOYEE(state, data) {
    // if not exists
    let exist = state.employees.find(c => c.employee_id == data.employee_id)
    if (!exist) {
      state.employees.push(data)
    }
  },
  SET_PROMOTION(state, data) {
    state.discountPromotion = data.promotion_discount
    state.freeItemPerAmount = data.promoion_free_item_per_amount
    state.freeCoinPerAmount = data.promotion_free_coin_per_amount
    state.buyItemFreeItem = data.promotion_buy_item_free_item,
    state.discountByRange = data.promotion_discount_by_range
  },
  SET_QUOATION_LIST(state, data) {
    state.quotations = data
  },
  SET_SALECONTRACT_LIST(state, data) {
    state.salecontracts = data
  },
  SET_LOCATION_ID(state, value) {
    state.location_id = value
  },
  SET_IS_PAID(state, data) {
    state.is_paid = data
  },
  SET_BRANCH_ID(state, value) {
    state.branch_id = value
  },
  CLEAR_SETUP(state) {
    state.locations = []
    state.suppliers = []
    state.products = []
    state.customers = []
    state.purchaseorders = []
    state.discountPromotion = []
    state.freeItemPerAmount = []
    state.freeCoinPerAmount = []
    state.buyItemFreeItem = []
    state.discountByRange = []
    state.quotations = []
    state.salecontracts = []
    state.employees = []
  },
  SET_SETTING(state, data) {
    state.setting = data
  },
  SET_IS_DELETED(state, data) {
    state.is_deleted = data
  },
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        location_id: context.state.location_id,
        filter: {
          is_paid: context.state.is_paid,
          is_deleted: context.state.is_deleted,
          search: context.state.search,
          date_between: _.join(
            context.state.searchAllDate && context.state.search
              ? undefined
              : context.state.dateRange,
            ','
          )
        }
      },
      attrubutes
    )
    return wholesale.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return wholesale.store(data)
  },
  update(context, { id, data }) {
    return wholesale.update(id, data)
  },
  updateMain(context, { id, data }) {
    return wholesale.updateMain(id, data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await wholesale.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  destroy(context, { id, data }) {
    return wholesale.destroy(id, data)
  },
  reprint(context, id) {
    return wholesale.reprint(id)
  },
  async getQuotation(context) {
    let response = await wholesale.quotation()
    context.commit('SET_QUOATION_LIST', response.data)
  },
  findQuotation(context, id) {
    return wholesale.findQuotation(id)
  },
  findSaleContract(context, id) {
    return wholesale.findSaleContract(id)
  },
  async getSalecontract(context) {
    let response = await wholesale.salecontract()
    context.commit('SET_SALECONTRACT_LIST', response.data)
  },
  async getCustomer(context, search) {
    let var_customer = await wholesale.formViewModel({
      params: {
        fnName: 'customer',
        search_customer: search
      }
    })
    context.commit('SET_CUSTOMER', var_customer.data['customer'])
  },
  async getSale(context, search) {
    let var_employee = await wholesale.formViewModel({
      params: {
        fnName: 'sale',
        search_sale: search
      }
    })
    context.commit('SET_EMPLOYEE', var_employee.data['sale'])
  },
  async getProduct(context, attributes = {}) {
    return await wholesale.product({ params: attributes })
  },
  bankProfile(context, attributes = {}) {
    return wholesale.bankProfile()
  },
  findProductSerial(context, { productId, attributes = {} }) {
    return wholesale.findProductSerial(productId, { params: attributes })
  },
  findSerial(context, serialNumber) {
    return wholesale.findSerial(serialNumber)
  },
  getFormViewData(context, { params }) {
    return wholesale.formViewModel({ params: params })
  },
  paymentMethod(context, attributes = {}) {
    return wholesale.paymentMethod()
  },
  // -------------------- promotion blog ------------------------------
  getPromotion(context) {
    return wholesale.promotion().then(response => {
      context.commit('SET_PROMOTION', response.data)
    })
  },
  viewItem(context, id) {
    return wholesale.viewItem(id)
  },
  exportExel(context, attrubutes = {}) {
    let params = Object.assign(
      {
        branch_id: context.state.branch_id,
        location_id: context.state.location_id,
        search: context.state.search,
        is_paid: context.state.is_paid,
        date_between: _.join(context.state.dateRange, ',')
      },
      attrubutes
    )
    return wholesale.exportExel(params)
  },
  async getProductInventory(context, data) {
    return await wholesale.productInventory(data)
  },
  onLoanRequest(context, data) {
    return wholesale.loanRequest(data)
  }
}
